export default "__VITE_ASSET__DBBLPwEG__"